import * as React from 'react';
import { PhoneNumber } from './components/PhoneNumber';
import { ShowPhoneButton } from './components/ShowPhoneButton';

export interface IPhoneButtonDesktopProps {
  phone: string;
  onPhoneShow?(): void;
}

export const PhoneButtonDesktop: React.FC<IPhoneButtonDesktopProps> = ({ phone, onPhoneShow }) => {
  const [isVisible, setIsVisible] = React.useState(false);

  const handleShowPhone = React.useCallback(() => {
    setIsVisible(true);

    if (onPhoneShow) {
      onPhoneShow();
    }
  }, [onPhoneShow]);

  return isVisible ? <PhoneNumber phone={phone} /> : <ShowPhoneButton onClick={handleShowPhone} />;
};
